import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {setUpdateButtonActiveStepToFalse,
        setUpdateButtonActiveStepToTrue
       } from '../../../../store/actions/main';
import {updadteHeightGelaender,
        updateWidthGelaender,
        updateStepsGelaender,
        updateWidthTotalGelaender,
        addSingleElementGelaender,
        updateSingleElementGelaender,
        deleteSingleElementGelaender,
        selectKindDimensionGelaender
        } from '../../../../store/actions/gelaender';
import {InputRadio} from '../../../../module/inputRadio';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import scrollToElement from '../../../../module/scrollToElement';


const Step_2 = (props) => {
   const [width_1, updateWidth1] = useState(0);
   const [width_2, updateWidth2] = useState(0);
   const [width_3, updateWidth3] = useState(0);
   const [width_total, updateWidthTotal] = useState(0);
   const [textfield_count, updateTextfieldCount] = useState(1);
   let textfield_items = [width_1, width_2, width_3];
   const [form, updateForm] = useState('');
   const [single_elements, updateSingleElements] = useState('');
   const [height, update_Height] = useState(0);
   let [kind_dimension, selectKindDimension] = useState('');

   useEffect(() => {
      updateItems();
   })

   const updateItems = () => {
      const {
            width_1,
            width_2,
            width_3,
            width_total,
            single_elements,
            height,
            kind_dimension
            } = props.data[props.modell_type].dimensions[0];
      let layout = props.data[props.modell_type].layout;

      updateWidthTotal(width_total);
      selectKindDimension(kind_dimension);
      updateSingleElements(single_elements);
      updateForm(layout);
      update_Height(height);

      //scroll to Next Button Container
      scrollToElement();

      //update width
      updateWidth1(width_1);
      updateWidth2(width_2);
      updateWidth3(width_3);

      if (layout === 'I-Form') {updateTextfieldCount(1);}
      if (layout === 'L-Form') updateTextfieldCount(2);
      if (layout === 'U-Form' || layout === 'Sonderform') updateTextfieldCount(3);

      //update steps
      if (props.modell_type === 3) props.updateSteps(1);
      else props.updateSteps(2);

      if((height && width_total) || props.data[props.modell_type].allVisitedSteps) {
         //update steps
         if (props.modell_type === 3) props.updateSteps(2);
         else props.updateSteps(3);
         props.setUpdateButtonActiveStepToFalse();
      } else {
         props.setUpdateButtonActiveStepToTrue()
      }

   }

   const updadteHeight = ev => {
      let height_value = ev.target.value;
      props.updadteHeight(height_value);
      updateItems();
   }

   const updateElementWidth = ev => {
      let field_element = ev.currentTarget.getAttribute('name');
      let value = ev.target.value;

      let width_object = {
         ident: field_element,
         value: value
      }

      props.updateWidth(width_object);
      props.updateWidthTotal();
      updateItems();

   }

   const addSingleElement = () => {
      props.addSingleElement();
      updateItems();
   }

   const updateSingleElement = ev => {
      let objectSingleElement = {
         index: ev.currentTarget.getAttribute('index'),
         value: ev.target.value
      }
      props.updateSingleElement(objectSingleElement);
      props.updateWidthTotal();
      updateItems();
   }

   const deleteSingleElement = ev => {
      let delete_index = ev.currentTarget.getAttribute('index');
      props.deleteSingleElement(delete_index);
      props.updateWidthTotal();
      updateItems();
   }

   const selectKindOfDimension = ev => {
      props.selectKindDimension(ev.target.value);
      updateItems();
   }

   const updateTotalWidth = ev => {
      let total_width_value = ev.target.value;
      props.updateWidthTotal(total_width_value);
      updateItems();
   }

   //update textfield items
   textfield_items.length = textfield_count;

   const arrayRadioItems = [
      {labalValue: 'Gesamt', labelTitel: 'Gesamtlänge angeben'},
      {labalValue: 'Einzeln', labelTitel: 'Einzelne Elemente angeben'}
   ]

       return (
           <div className="step_wrapper">
             <h2 className="step_header">Wie möchten Sie Ihre Maße eingeben?</h2>
              <div className="step_icon_wrapper">
                 <div className="inner_masseMenge_wrapper">
                  <div className="textfield-wrapper">
                     <InputRadio
                        arial_label='Maße'
                        name='Maße'
                        value={kind_dimension}
                        onChange={selectKindOfDimension}
                        arrayRadioItems={arrayRadioItems}
                     />
                     {kind_dimension === 'Gesamt'?
                           <TextField
                              className="textfield-masse-quantity"
                              label="Gesamtlänge (in m)"
                              type="number"
                              rowsMax={1}
                              value={width_total}
                              name="totalwidth"
                              onChange={updateTotalWidth}
                           >
                           </TextField>
                        : ''
                     }
                     {kind_dimension === 'Einzeln'?
                        <>
                           {textfield_items.map((elem, index) => (
                                    <TextField
                                       key={index}
                                       className="textfield-masse-quantity"
                                       label={textfield_items.length === 1? 'Länge für das Element (in cm)' : 'Länge für das '+(index+1)+'. Element (in cm)'}
                                       type="number"
                                       rowsMax={1}
                                       value={elem}
                                       name={'width_'+(index+1)}
                                       onChange={updateElementWidth}
                                       >
                                    </TextField>
                              ))}
                              {form === 'Sonderform'?
                                 <div className="textfield-wrapper">
                                    {single_elements.map((elem, index) => (
                                       <div className='single_element_wrapper' key={index}>
                                          <DeleteForeverIcon onClick={deleteSingleElement} index={index} className='delete-icon' />
                                          <TextField
                                             className="textfield-masse-quantity"
                                             label={'Länge für das '+(index+4)+'. Element (in cm)'}
                                             type="number"
                                             rowsMax={1}
                                             value={elem.width}
                                             inputProps={{index: index}}
                                             name={'width_'+(index+1)}
                                             onChange={updateSingleElement}
                                             >
                                          </TextField>
                                       </div>
                                    ))}
                                    <Button className='addButton' onClick={addSingleElement} startIcon={<AddCircleIcon />}>Weiteres Element hinzufügen</Button>
                                 </div>
                              : ''
                              }
                        </>
                     :''
                     }
                     {kind_dimension === 'Gesamt'||kind_dimension === 'Einzeln'?
                        <TextField
                              className="textfield-masse-quantity "
                              label="Höhe (in cm)"
                              type="number"
                              rowsMax={1}
                              value={height}
                              name="height"
                              onChange={updadteHeight}
                           >
                        </TextField>
                        :''
                     }
                  </div>
                </div>
            </div>
          </div>
       )
}

const mapStateToProps = state => {
    return {
        modell_type: state.gelaenderReducer.modell_type,
        data: state.gelaenderReducer.data
    }
}

const mapDispatchToProps = dispatch =>  {
   return {
      setUpdateButtonActiveStepToFalse: () => dispatch(setUpdateButtonActiveStepToFalse()),
      setUpdateButtonActiveStepToTrue: () => dispatch(setUpdateButtonActiveStepToTrue()),
      updadteHeight: ev => dispatch(updadteHeightGelaender(ev)),
      updateWidth: ev => dispatch(updateWidthGelaender(ev)),
      updateSteps: ev => dispatch(updateStepsGelaender(ev)),
      updateWidthTotal: ev => dispatch(updateWidthTotalGelaender(ev)),
      addSingleElement: () => dispatch(addSingleElementGelaender()),
      updateSingleElement: ev => dispatch(updateSingleElementGelaender(ev)),
      deleteSingleElement: ev => dispatch(deleteSingleElementGelaender(ev)),
      selectKindDimension: ev => dispatch(selectKindDimensionGelaender(ev))
   }
}


export default connect(mapStateToProps, mapDispatchToProps)(Step_2);
